/**
 * @file 公告 - 基本信息
 */
import { Form, Input } from 'antd'

import { RichTextEditor } from 'packages/components/RichText'

import { CommonBasicInfo } from '@/components/CommonBasicInfo'

import { BasicInfoProps } from '../types'
import { EntryComponentsWrapper } from 'packages/theme'

/**
 * 公告 - 基本信息
 *
 * @param param0 - 参数
 * @param param0.form - 表单实例
 * @param param0.basicInfoRef - 基本信息 ref
 * @param param0.commonBasicInfo - 基本信息
 * @param param0.setTitle - 设置标题
 * @param param0.activityTaskOptions - 任务选项
 * @param param0.openTypeDisabled - 是否关闭开启设置
 * @returns  component
 */
export const BasicInfo: React.FC<
  BasicInfoProps & {
    openTypeDisabled?: boolean
  }
> = ({
  form,
  basicInfoRef,
  commonBasicInfo,
  setTitle,
  activityTaskOptions,
  openTypeDisabled,
}) => {
  return (
    <EntryComponentsWrapper>
      <Form
        colon={false}
        form={form}
        wrapperCol={{ span: 22 }}
        labelCol={{ span: 2 }}
        initialValues={{
          isShow: true,
        }}
      >
        <Form.Item
          label="公告标题"
          name="name"
          rules={[{ required: true, message: '请输入公告标题' }]}
        >
          <Input
            placeholder="请输入公告标题"
            onChange={(e) => {
              setTitle && setTitle(e.target.value)
            }}
            maxLength={200}
          />
        </Form.Item>
        <Form.Item
          label="公告简介"
          name="description"
          rules={[{ required: true, message: '请输入公告简介' }]}
        >
          <RichTextEditor />
        </Form.Item>
        <CommonBasicInfo
          form={form}
          ref={basicInfoRef}
          value={commonBasicInfo}
          activityTaskOptions={activityTaskOptions || []}
          openTypeDisabled={!!openTypeDisabled}
        />
      </Form>
    </EntryComponentsWrapper>
  )
}
